import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import {
  Card,
  Col,
  Row,
} from "react-bootstrap";
import { updateSettings, fetchSettings, updateBrandingColor } from "../../actions/settings";
import { getCurrentCognitoUser } from "../../actions/auth";
import ImageUploader from "../../components/settings/ImageUploader";
import CCColorPicker from "../../components/common/CCColorPicker";
import imgCamelLogo from '../../assets/images/content-camel-logo.png';
import { BRANDING } from "../../constants/Branding";
import "./Branding.scss";

class Branding extends Component {
  constructor(props) {
    super(props);

    this.state = {
      color: _.get(props.settings, `${BRANDING.SETTING}.${BRANDING.COLOR}`, '#ffffff'),
      logoImageurl: imgCamelLogo
    };
  }

  static getDerivedStateFromProps(props, state) {
    return {
      color: _.get(props.settings, `${BRANDING.SETTING}.${BRANDING.COLOR}`, state.color)
    };
  }

  onChangeValue = (field, value) => {
    this.setState({ [field]: value }, () => {
      this.props.updateBrandingColor(value);
    });
  }

  changeLogoImage = () => {
    const reader = new FileReader();
  
    reader.onloadend = (e) => {
      this.setState({ logoImageurl: [reader.result] });
    };
  }

  render() {
    const { color } = this.state;
    const brandingLogoUrl = _.get(this.props.settings, `${BRANDING.SETTING}.${BRANDING.LOGO}`, null);
    const avatarUrl = _.get(this.props.cognitoUser, 'attributes["custom:avatar_thumbnail"]', BRANDING.AVATAR_FALLBACK_URL);

    return (
      <div className="branding-container position-relative">
        <Row className="full-width">
          <Col>
            <Row className="full-width">
              <Card bg="light" className="full-width full-height">
                <Card.Header>Styling</Card.Header>
                <Card.Body>
                  Alter your design elements here.
                  <div className="branding-settings-box">
                    <div className="brand-settings-item">
                      <div className="title">Favicon</div>
                      <div className="logo-picker">
                        <ImageUploader
                          user={this.props.user}
                          type={BRANDING.FAVICON}
                          imageUrl={_.get(this.props.settings, `${BRANDING.SETTING}.${BRANDING.FAVICON}`, null)}
                          getCurrentCognitoUser={this.props.getCurrentCognitoUser}
                          Auth={this.props.Auth}
                          onUploadSuccess={this.props.fetchSettings}
                        />
                      </div>
                    </div>
                    <div className="brand-settings-item">
                      <div className="title">Accent color</div>
                      <CCColorPicker value={color} onChange={(hexColor) => this.onChangeValue(BRANDING.COLOR, hexColor)} />
                    </div>
                    <div className="brand-settings-item">
                      <div className="title">Logo</div>
                      <div className="logo-picker">
                        <ImageUploader
                          user={this.props.user}
                          type={BRANDING.LOGO}
                          imageUrl={_.get(this.props.settings, `${BRANDING.SETTING}.${BRANDING.LOGO}`, null)}
                          getCurrentCognitoUser={this.props.getCurrentCognitoUser}
                          Auth={this.props.Auth}
                          onUploadSuccess={this.props.fetchSettings}
                        />
                      </div>
                    </div>
                    <div className="brand-settings-item">
                      <div className="title">Share Thumbnail</div>
                      <div className="logo-picker">
                        <ImageUploader
                          user={this.props.user}
                          type={BRANDING.SITE_IMAGE}
                          imageUrl={_.get(this.props.settings, `${BRANDING.SETTING}.${BRANDING.SITE_IMAGE}`, null)}
                          getCurrentCognitoUser={this.props.getCurrentCognitoUser}
                          Auth={this.props.Auth}
                          onUploadSuccess={this.props.fetchSettings}
                        />
                      </div>
                      <div className="description">
                        <div>Used as social share images.</div>
                        <div>Please use .jpg or .png with non-transparent background.</div>
                        <div>Recommended dimensions of <b>1280x720</b></div>
                        <div>Used as Sites og:image or twitter:image</div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
                <Card.Body>
                  <b>Sites Preview</b>
                  <div className="preview-container">
                    <div className="preview-page">
                      <div className="branding-area">
                        <div className="triangle-background">
                          <div className="triangle1" style={{ borderTop: `100px solid ${color}` }} />
                          <div className="triangle2" style={{ borderTop: `110px solid ${color}` }}/>
                        </div>
                        { brandingLogoUrl && 
                          <img className="branding-logo" src={_.get(this.props.settings, `${BRANDING.SETTING}.${BRANDING.LOGO}`, null)} alt="branding logo" />
                        }
                      </div>
                      <div className="items-area">
                        <div className="site-header">
                          { avatarUrl &&
                          <div className="avatar">
                            <img src={avatarUrl} alt="avatar" />
                          </div>
                          }
                          <div className="site-info">
                            <div className="site-title">Site Title</div>
                            <div className="site-description">Site Description</div>
                          </div>
                        </div>
                        <div className="items-container">
                          <div className="item-container">
                            <div className="thumbnail-section" />
                            <div className="content-section" />
                          </div>
                          <div className="item-container">
                            <div className="thumbnail-section" />
                            <div className="content-section" />
                          </div>
                          <div className="item-container">
                            <div className="thumbnail-section" />
                            <div className="content-section" />
                          </div>
                          <div className="item-container">
                            <div className="thumbnail-section" />
                            <div className="content-section" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  user: state.auth.tenant || {},
  Auth: state.auth.Auth,
  cognitoUser: state.auth.cognitoUser,
});

const mapDispatchToProps = dispatch => 
bindActionCreators({
  updateSettings,
  fetchSettings,
  updateBrandingColor,
  getCurrentCognitoUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Branding);
